var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-question" }, [
    _c("div", { staticClass: "question_wrap" }, [
      _c(
        "div",
        { staticClass: "question_wrap__left_wrap" },
        [
          [
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "right" } },
              [
                _c(
                  "div",
                  { staticClass: "content_wrap" },
                  [
                    _vm._l(_vm.data.content, function (u, o) {
                      return _c(
                        "div",
                        { key: o },
                        [
                          u.type == _vm.answerContentTypeEnum.Object.TEXT.code
                            ? [
                                _c("span", {
                                  staticStyle: {
                                    "white-space": "pre-wrap",
                                    "word-break": "break-all",
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(u.value || ""),
                                  },
                                }),
                              ]
                            : [
                                _vm._l(
                                  _vm.answerContentTypeEnum.Array,
                                  function (e, i) {
                                    return [
                                      e.code !==
                                      _vm.answerContentTypeEnum.Object.TEXT.code
                                        ? _vm._t(e.code + o, null, {
                                            data: {
                                              contentTypeData: e,
                                              params: _vm.data,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                        ],
                        2
                      )
                    }),
                    _vm.dataProp.tools && _vm.dataProp.tools.length > 0
                      ? _c(
                          "p",
                          {
                            staticStyle: {
                              "font-style": "italic",
                              "text-decoration": "underline",
                            },
                          },
                          [
                            _vm._v(" 当前引用： "),
                            _vm._l(_vm.dataProp.tools, function (item, index) {
                              return _c("span", { key: index }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.btnListConfig[item.type]) +
                                    "； "
                                ),
                              ])
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _vm.dataProp.images && _vm.dataProp.images.length > 0
              ? _c(
                  "div",
                  { staticClass: "images_wrap" },
                  _vm._l(_vm.dataProp.images, function (image, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "image-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleImageClick(image)
                          },
                        },
                      },
                      [
                        _c("IconFileType", {
                          staticClass: "file-icon",
                          attrs: { fileName: image.name },
                        }),
                        _c("span", { staticClass: "image-name" }, [
                          _vm._v(_vm._s(image.name)),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "operate_wrap" },
              [
                _c(
                  "ActionsItem",
                  _vm._g(
                    _vm._b(
                      {
                        attrs: {
                          dataProp: _vm.data,
                          indexProp: _vm.index,
                          formModalDataProp: _vm.formModalDataProp,
                        },
                      },
                      "ActionsItem",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  )
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }